import React from 'react';

// A thin decorative band: a repeating cross motif flanked by a slim
// green/yellow/red accent line, used between major sections.
function SectionDivider({ className = '' }) {
  return (
    <div className={`flex items-center justify-center gap-3 py-6 ${className}`}>
      <span className="h-[2px] w-10 bg-flag-green/70" />
      <span className="h-[2px] w-10 bg-flag-yellow/70" />
      <svg width="120" height="16" viewBox="0 0 120 16" fill="none" className="text-gold">
        {[0, 1, 2, 3, 4].map((i) => (
          <g key={i} transform={`translate(${i * 24 + 4}, 0)`}>
            <path
              d="M8 0V16M0 8H16"
              stroke="currentColor"
              strokeWidth="1.5"
              opacity="0.6"
            />
          </g>
        ))}
      </svg>
      <span className="h-[2px] w-10 bg-flag-yellow/70" />
      <span className="h-[2px] w-10 bg-flag-red/70" />
    </div>
  );
}

export default SectionDivider;
